export default __webpack_public_path__ + "assets/user.81716a75.svg";